import {
  AUDIO_SET_ENABLED,
  AUDIO_SET_VAD_ENABLED,
  AUDIO_SET_STT_ENABLED,
  AUDIO_START,
  AUDIO_STOP,
  AUDIO_SPEECH_SEGMENT_READY,
  AUDIO_TRANSCRIBE_REQUEST,
  AUDIO_TRANSCRIBE_RESULT,
  AUDIO_ERROR,
  AUDIO_SET_HEARING,
  AUDIO_SET_ROBOT_SPEAKING,
  TTS_SPEAK_TOKEN,
  USER_SAID,
  AUDIO_SET_TTS_WORD, SET_HIGHLIGHT_RANGE, AUDIO_SOME_NOISE,
} from './consts'

// master enable
export const audioSetEnabled = (enabled) => ({
  type: AUDIO_SET_ENABLED,
  enabled,
})

// independent switches
export const audioSetVadEnabled = (enabled) => ({
  type: AUDIO_SET_VAD_ENABLED,
  enabled,
})

export const audioSetSttEnabled = (enabled) => ({
  type: AUDIO_SET_STT_ENABLED,
  enabled,
})

export const audioStart = () => ({type: AUDIO_START})
export const audioStop = () => ({type: AUDIO_STOP})

export const audioSpeechSegmentReady = (floatAudio) => ({
  type: AUDIO_SPEECH_SEGMENT_READY,
  floatAudio,
})

export const audioTranscribeRequest = () => ({
  type: AUDIO_TRANSCRIBE_REQUEST,
})

export const audioTranscribeResult = (payload) => ({
  type: AUDIO_TRANSCRIBE_RESULT,
  payload, // { isOk, text, message }
})

export const audioError = (error) => ({
  type: AUDIO_ERROR,
  error,
})

export const audioSetHearing = (hearing) => ({
  type: AUDIO_SET_HEARING,
  hearing, // 'silence' | 'shaky'
})

export const audioSetRobotSpeaking = (speaking) => ({
  type: AUDIO_SET_ROBOT_SPEAKING,
  speaking, // boolean
})

export const ttsSpeakToken = (token, shouldFlush = false) => ({
  type: TTS_SPEAK_TOKEN,
  token,
  shouldFlush,
})

export const audioSetTtsWord = (payload) => ({
  type: AUDIO_SET_TTS_WORD,
  payload,
})

export const userSaidAction = (rawText) => ({
  type: USER_SAID,
  rawText
})

export const setHighlightRange = (start, end) => ({
  type: SET_HIGHLIGHT_RANGE,
  payload: { start, end },
})

export const audioSomeNoise = (speechInfo) => ({
  type: AUDIO_SOME_NOISE,
  payload: speechInfo,
})
